import { useState } from 'react'
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import AppSettings from './components/AppSettings'
import AiConfigSettings from './components/AiConfigSettings'
import ManageUsersSettings from './components/ManageUsersSettings'

type SettingsTabConfig = {
	label: string,
	hidden?: boolean,
	component: () => JSX.Element
}

const SETTINGS_TABS: SettingsTabConfig[] = [
	{ label: 'App', hidden: true, component: AppSettings },
	{ label: 'AI Config', component: AiConfigSettings },
	{ label: 'Manage Users', hidden: true, component: ManageUsersSettings }
]

export default function Settings() {

	const visibleTabs = SETTINGS_TABS.filter((tab) => !tab.hidden)
	const [selectedTab, setSelectedTab] = useState(0)

	return (
		<div>
			<Tabs
				value={selectedTab}
				onChange={(_, value) => setSelectedTab(value)}>
				{visibleTabs.map((tab) => (
					<Tab key={tab.label} label={tab.label} />
				))}
			</Tabs>
			{visibleTabs.map((tab, index) => (
				selectedTab === index && (
					<tab.component key={tab.label} />
				)
			))}
		</div>
	)
}
